import React, { useContext } from 'react';
import styled from 'styled-components';
import { MainContext } from '../../context/MainProvider';
import { SET_COLUMN_FILTERS } from '../../context/actionTypes';

const FilterInputField = styled.input`
  font-family: inherit;
  height: 30px;
  padding-left: 6px;
  width: 90%;
  border: solid #dee2e6 1px;
  margin-top: 8px;
  border-radius: 15px;

  &:focus {
    outline: none;
  }
`;

function FilterInput({ column }) {
  const {
    id, filterValue, setFilter, Header,
  } = column;
  const [, dispatch] = useContext(MainContext);

  return (
    <FilterInputField
      key={id}
      value={filterValue || ''}
      placeholder="Filter ..."
      onChange={(e) => {
        setFilter(e.target.value);
        dispatch({
          type: SET_COLUMN_FILTERS,
          payload: {
            filterKey: e.target.name,
            filterValue: e.target.value,
          },
        });
      }}
      name={Header}
    />
  );
}

export { FilterInput };
